import gql from 'graphql-tag';

import type { Workspace } from 'src/data/workspace';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp, type GraphQLEdgesResult, unwrapEdges } from 'src/lib/graphql';

import { WORKSPACE_ASSOCIATIONS_FRAGMENT, WORKSPACE_FRAGMENT } from './schema';

const QUERY = gql`
  query Workspace($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          ...Workspace
          ...WorkspaceAssociations
        }
      }
    }
  }
  ${WORKSPACE_FRAGMENT}
  ${WORKSPACE_ASSOCIATIONS_FRAGMENT}
`;

interface Params {
  customerId: ID;
  id: ID;
}

interface Options {
  abortSignal?: AbortSignal;
}

export const queryWorkspace = async ({ customerId, id }: Params, options?: Options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId, id },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<GraphQLEdgesResult<Workspace>>(result.data);
  const workspaces = unwrapEdges(data?.edges);
  return workspaces[0];
};
